export const ADD_BOLLYWOOD_MOVIES = 'ADD_BOLLYWOOD_MOVIES';
export const ADD_HOLLYWOOD_MOVIES = 'ADD_HOLLYWOOD_MOVIES';
export const ADD_ACTION_MOVIES = 'ADD_ACTION_MOVIES';
export const ADD_COMEDY_MOVIES = 'ADD_COMEDY_MOVIES';
export const ADD_HORROR_MOVIES = 'ADD_HORROR_MOVIES';
export const ADD_TRENDING_MOVIE = 'ADD_TRENDING_MOVIE'

export const ADD_SEARCH_RESULT = 'ADD_SEARCH_RESULT';
export const ADD_SEARCH_TITLE = 'ADD_SEARCH_TITLE';

export const ADD_MOVIE_DETAILS = 'ADD_MOVIE_DETAILS';
export const ADD_MOVIE_BACK = 'ADD_MOVIE_BACK';
export const ADD_MOVIE_VIDEO = 'ADD_MOVIE_VIDEO';
export const ADD_MORE_MOVIES = 'ADD_MORE_MOVIES';

// export const CHANGE_THEME = 'CHANGE_THEME';


// export function changeTheme(){
//     return{
//         type:CHANGE_THEME
//     }
// }

export function handleBollywoodMovies() {
    const url = `https://api.themoviedb.org/3/discover/movie?api_key=df5924b75b0bf99fda95e6b32ee61a83&sort_by=popularity.desc&certification_country=india&include_adult=false&include_video=false&page=1&primary_release_year=2021&year=2021&with_original_language=hi&with_watch_monetization_types=flatrate`;
    return function (dispatch) {
        fetch(url)
        .then(response => response.json() )
        .then(movies => {
            console.log(movies.results);
            dispatch(addBollywoodMovies(movies.results))
        })
    }
}

export function addBollywoodMovies(movies){
    console.log(movies);
    return{
        type:ADD_BOLLYWOOD_MOVIES,
        movies
    }
}

export function handleTrendingMovie() {
    const url = `https://api.themoviedb.org/3/trending/movie/day?api_key=df5924b75b0bf99fda95e6b32ee61a83`;
    return function (dispatch) {
        fetch(url)
        .then(response => response.json() )
        .then(movie => {
            console.log(movie.results);
            dispatch(addTrendingMovie(movie.results[0]))
        })
    }
}

export function addTrendingMovie(movie){
    console.log(movie);
    return{
        type:ADD_TRENDING_MOVIE,
        movie
    }
}
export function handleHollywoodMovies() {
    const url = `https://api.themoviedb.org/3/discover/movie?api_key=df5924b75b0bf99fda95e6b32ee61a83&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_watch_monetization_types=flatrate`;
    return function (dispatch) {
        fetch(url)
        .then(response => response.json())
        .then(movies => {
            dispatch(addHollywoodMovies(movies.results))
        })
    }
}

export function addHollywoodMovies(movies){
    return{
        type:ADD_HOLLYWOOD_MOVIES,
        movies
    }
}
export function handleActionMovies() {
    const url = `https://api.themoviedb.org/3/discover/movie?api_key=df5924b75b0bf99fda95e6b32ee61a83&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_genres=28&with_watch_monetization_types=flatrate`;
    return function (dispatch) {
        fetch(url)
        .then(response => response.json())
        .then(movies => {
            dispatch(addActionMovies(movies.results))
        })
    }
}

export function addActionMovies(movies){
    return{
        type:ADD_ACTION_MOVIES,
        movies
    }
}
export function handleComedyMovies() {
    const url = `https://api.themoviedb.org/3/discover/movie?api_key=df5924b75b0bf99fda95e6b32ee61a83&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_genres=35&with_watch_monetization_types=flatrate`;
    return function (dispatch) {
        fetch(url)
        .then(response => response.json())
        .then(movies => {
            dispatch(addComedyMovies(movies.results))
        })
    }
}

export function addComedyMovies(movies){
    return{
        type:ADD_COMEDY_MOVIES,
        movies
    }
}
export function handleHorrorMovies() {
    const url = `https://api.themoviedb.org/3/discover/movie?api_key=df5924b75b0bf99fda95e6b32ee61a83&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_genres=36&with_watch_monetization_types=flatrate`;
    return function (dispatch) {
        fetch(url)
        .then(response => response.json())
        .then(movies => {
            dispatch(addHorrorMovies(movies.results))
        })
    }
}

export function addHorrorMovies(movies){
    return{
        type:ADD_HORROR_MOVIES,
        movies
    }
}


export function handleSearch(movie){
    console.log('handle search');
    const url =`https://www.omdbapi.com/?apikey=ba1534f1&s=${movie}`;
    return function(dispatch){
        fetch(url)
        .then(response=>response.json())
        .then((movies)=>{
            console.log(movies.search);
            dispatch(addSearchResults(movies.Search))
        });
    }
}

export function addSearchResults(movies){
    return {
        type: ADD_SEARCH_RESULT,
        movies
    }
}

export function addSearchTitle(title){
    return {
        type:ADD_SEARCH_TITLE,
        title
    }
}

export function handleMovieDetails(movie){
    const url = `https://www.omdbapi.com/?apikey=ba1534f1&t=${movie}`;
    return function(dispatch){
        fetch(url)
        .then(response=>response.json())
        .then(movie=>{
            dispatch(handleMovieVideo(movie.imdbID));
            dispatch(addMovieDetails(movie));
        });
    }
}
export function handleTvDetails(movie){
    const url = `https://www.omdbapi.com/?apikey=ba1534f1&t=${movie}`;
    return function(dispatch){
        fetch(url)
        .then(response=>response.json())
        .then(movie=>{
            console.log(movie);
            dispatch(handleMovieVideo(movie.imdbID));
            dispatch(addMovieDetails(movie));
        });
    }
}

export function handleSearchMovie(id){
    const url = `https://www.omdbapi.com/?apikey=ba1534f1&i=${id}`;
    return function(dispatch){
        fetch(url)
        .then(response=>response.json())
        .then(movie=>{
            console.log(movie);
            dispatch(handleMovieVideo(movie.imdbID));
            dispatch(addMovieDetails(movie));
        });
    }
}

export function addMovieDetails(movie){
    return {
        type:ADD_MOVIE_DETAILS,
        movie
    }
}

export function handleMovieBack(movie){
    const url = ``;
    return function(dispatch){
        fetch(url)
        .then(response=>response.json())
        .then(movie=>{
            dispatch(addMovieBack(movie));
        })
    }
}

export function addMovieBack(back){
    return {
        type: ADD_MOVIE_BACK,
        back
    }
}



export function handleSearchMovieDetail(id,type){
    const url = `https://api.themoviedb.org/3/find/${id}?api_key=df5924b75b0bf99fda95e6b32ee61a83&external_source=imdb_id`;
    return function(dispatch){
        fetch(url)
        .then(response=>response.json())
        .then(data=>{
            if(type=='movie'){
            console.log(data.movie_results[0]);
            dispatch(addMovieBack(data.movie_results[0].backdrop_path));
           
            dispatch(handleMoreMovies(data.movie_results[0].original_language,data.movie_results[0].genre_ids[0]));
            }
            if(type=='series'){
                dispatch(addMovieBack(data.tv_results[0].backdrop_path));
               
                dispatch(handleMoreTvs(data.tv_results[0].original_language,data.tv_results[0].genre_ids[0]));
            }
        })
    }
}

export function handleMovieVideo(movie_id){
    console.log('Video')
    const url = `https://api.themoviedb.org/3/movie/${movie_id}/videos?api_key=df5924b75b0bf99fda95e6b32ee61a83`;
    return function(dispatch){
        fetch(url)
        .then(response=>response.json())
        .then(data=>{
            console.log(data);
            dispatch(addMovieVideo(data.results));
        })
    }
}

export function handleTvVideo(movie_id){
    console.log('Video')
    const url = `https://api.themoviedb.org/3/tv/${movie_id}/videos?api_key=df5924b75b0bf99fda95e6b32ee61a83`;
    return function(dispatch){
        fetch(url)
        .then(response=>response.json())
        .then(data=>{
            console.log(data);
            dispatch(addMovieVideo(data.results));
        })
    }
}

export function addMovieVideo(data){
    return {
        type:ADD_MOVIE_VIDEO,
        data
    }
}

export function handleMoreMovies(lan,genre){
    const url =`https://api.themoviedb.org/3/discover/movie?api_key=df5924b75b0bf99fda95e6b32ee61a83&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_genres=${genre}&with_keywords=horror&with_original_language=${lan}&with_watch_monetization_types=flatrate`;
    return function(dispatch){
        fetch(url)
        .then(response => response.json())
        .then(data=>{
            console.log(data);
            dispatch(addMoreMovies(data.results));
        })
    }
}

export function handleMoreTvs(lan,genre){
    console.log('More Tvs');
    const url =`https://api.themoviedb.org/3/discover/tv?api_key=df5924b75b0bf99fda95e6b32ee61a83&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_genres=${genre}&with_keywords=horror&with_original_language=${lan}&with_watch_monetization_types=flatrate`;
    return function(dispatch){
        fetch(url)
        .then(response => response.json())
        .then(data=>{
            console.log(data);
            dispatch(addMoreMovies(data.results));
        })
    }
}

export function addMoreMovies(data){
    console.log(data);
    return {
        type:ADD_MORE_MOVIES,
        data

    }
}